<template>
  <div>
    <form>
      <div class="form-group">
        <label class="form-label col-label required">{{
          $t('hospitalProfile.hospitalName')
        }}</label>
        <input
          type="text"
          class="form-control"
          v-model="model.hospital_name"
          :placeholder="$t('hospitalProfile.hospitalName')"
          :class="{ 'is-invalid': errors.has('hospital_name') }"
        />
        <div class="invalid-feedback" v-if="errors.has('hospital_name')">
          {{ errors.first('hospital_name') }}
        </div>
      </div>
      <div class="form-group">
        <label class="form-label col-label required">{{
          $t('hospitalProfile.address')
        }}</label>
        <input
          type="text"
          class="form-control"
          v-model="model.address"
          :placeholder="$t('hospitalProfile.address')"
          :class="{ 'is-invalid': errors.has('address') }"
        />
        <div class="invalid-feedback" v-if="errors.has('address')">
          {{ errors.first('address') }}
        </div>
      </div>
      <div class="form-group">
        <label class="form-label col-label required">{{
          $t('hospitalProfile.contactNumber')
        }}</label>
        <input
          type="number"
          class="form-control"
          v-model="model.contact_number"
          :placeholder="$t('hospitalProfile.contactNumber')"
          :class="{ 'is-invalid': errors.has('contact_number') }"
        />
        <div class="invalid-feedback" v-if="errors.has('contact_number')">
          {{ errors.first('contact_number') }}
        </div>
      </div>
      <div class="text-right">
        <ts-button @click="cancel()" v-if="editing == true">
          {{ $t('cancel') }}
        </ts-button>
        <ts-button
          class="ml-2"
          color="primary"
          :disabled="saving"
          :waiting="saving"
          @click="update"
          v-if="editing == true"
        >
          {{ $t('update') }}
        </ts-button>
        <ts-button
          class="ml-2"
          color="primary"
          :disabled="saving"
          :waiting="saving"
          @click="save"
          v-else
        >
          {{ $t('save') }}
        </ts-button>
      </div>
    </form>
  </div>
</template>
<script>
import { Errors } from 'form-backend-validation'
export default {
  name: 'hospital-profile',
  props: ['edit'],

  data () {
    return {
      errors: new Errors(),
      saving: false,
      editing: false,
      model: {
        hospital_name: '',
        address: '',
        contact_number: ''
      }
    }
  },
  methods: {
    async save () {
      this.saving = true
      this.errors = new Errors()
      try {
        let response = await this.$store.dispatch(
          'hospitalProfile/create',
          this.model
        )
        this.$toasted.success(response.message)
        this.$emit('success_create')
        this.clearForm()
      } catch (error) {
        this.errors = new Errors(error.errors)
        this.$toasted.error(error.message)
      }
      this.saving = false
    },
    async update () {
      this.saving = true
      this.errors = new Errors()
      try {
        let response = await this.$store.dispatch(
          'hospitalProfile/update',
          this.model
        )

        this.$toasted.success(response.message)
        this.$router.push({ name: 'hospital-profile' })
        this.editing = false
        this.$emit('success_create')
        this.$emit('success_update')
        this.clearForm()
      } catch (error) {
        this.editing = true
        this.errors = new Errors(error.errors)
        this.$toasted.error(error.message)
      }
      this.saving = false
    },
    setEdit () {
      if (this.edit === null || this.edit === undefined) return
      this.errors = new Errors()
      this.model = Object.assign({}, this.edit)
      this.editing = true
    },
    clearForm () {
      this.model.hospital_name = ''
      this.model.address = ''
      this.model.contact_number = ''
    },
    cancel () {
      this.editing = false
      this.clearForm()
      this.$emit('cancel')
      this.$router.push({ name: 'hospital-profile' })
    }
  },
  watch: {
    edit: {
      handler () {
        if (this.edit) {
          this.setEdit()
          this.editing = true
        }
      }
    }
  }
}
</script>
